import { render, staticRenderFns } from "./ShippingPlanSplit.vue?vue&type=template&id=4ba39cd2&scoped=true&"
import script from "./ShippingPlanSplit.vue?vue&type=script&lang=js&"
export * from "./ShippingPlanSplit.vue?vue&type=script&lang=js&"
import style0 from "./ShippingPlanSplit.vue?vue&type=style&index=0&id=4ba39cd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba39cd2",
  null
  
)

export default component.exports